import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import styleFactory from './watchlist-icon.style';

/* eslint-disable max-len */
import { jsx as ___EmotionJSX } from "@emotion/core";
var WatchlistIcon = props => {
  var active = props.active;
  var styles = styleFactory(props);
  return ___EmotionJSX("svg", {
    css: styles.icon,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, ___EmotionJSX("path", {
    css: /*#__PURE__*/_css([styles.path, active && styles.active]),
    stroke: "currentColor",
    d: "M20.5 9h-6l-2-5.7a.5.5 0 0 0-.9 0L9.5 9h-6a.5.5 0 0 0-.3.9L8 13.6l-2.4 6.7a.5.5 0 0 0 .9.6l5.5-4.3 5.5 4.2a.6.6 0 0 0 .9-.6L16 13.6l4.8-3.6a.5.5 0 0 0-.3-1z"
  }));
};
WatchlistIcon.propTypes = {
  active: PropTypes.bool
};
WatchlistIcon.defaultProps = {
  active: false
};
export default WatchlistIcon;